// Typelizer digest f8c79fee1d679dbf015d05c0a1dea04d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/purchase_orders/:purchase_order_id/pdf */
  show: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/pdf', params, options),
    method: 'get',
  }),
}
